import { Button, ButtonColor } from '@ctouch-europe-b-v/react-component-library';

const SupportButton = () => {
  return <Button variant={ButtonColor.white} title="Contact Support" iconName="fa-headset" onClick={() => window.open("https://ctouch.eu/nl/contact", "_blank", "noreferrer")}/>
}

export default SupportButton;